import { Divider } from "@mui/material";
import { FC } from "react";
import {
  List,
  ListItem,
  ListItemSecondaryAction,
} from "@mui/material";
import { H4 } from "../components/Typography";

interface ReturnInformationProps {
  item: {
    label: string;
    value: any;
    data?: { name: string; value: any }[];
    metadata?: {
      date_of_inception: string;
      option_name: string;
      risk_rating: string;
      nav: string;
      fund_type: string;
      fund_size: string;
      fund_manager: string;
      asset_category: string;
      benchmark: string;
      exit_load: any;
    };
    exit_load?: {
      exit_load_period_remark: string;
    };
  };
}
const FundInformation: FC<ReturnInformationProps> = ({ item }) => {

  const data = [
    {
      name: "Date Of Inception",
      value: item?.metadata?.date_of_inception ?? "",
    },
    {
      name: "Option Name",
      value: item.metadata?.option_name ?? "",
    },
    {
      name: "Risk Rating",
      value: item.metadata?.risk_rating ?? "",
    },
    {
      name: "NAV",
      value: item.metadata?.nav ?? "",
    },
    {
      name: "Fund Size",
      value: "₹" + item.metadata?.fund_size + "Cr" ?? "",
    },
    {
      name: "Fund Manager",
      value: item.metadata?.fund_manager ?? "",
    },
    {
      name: "Asset Category",
      value: item.metadata?.asset_category ?? "",
    },
    {
      name: "Fund Type",
      value: item.metadata?.fund_type ?? "",
    },
    {
      name: "Benchmark",
      value: item.metadata?.benchmark ?? "",
    },
    {
      name: "Exit Load",
      value: `${item.metadata?.exit_load.exit_load_period_remark.toUpperCase()}`,
    },
  ];


  return (
    <>
    
      <List>
        {data?.map((data, index) => (
          <>
            <ListItem
              disableGutters
              sx={{
                display: "flex",
                justifyContent: "space-between",
                py: 0.5,
                px: 2,
                pl:2,
                pt:1,pb:1,
                background: "#fff",
              }}
            >
              <H4 sx={{ minWidth: "50%" }}>{data.name}</H4>
              <ListItemSecondaryAction>
                <H4 sx={{ minWidth: "50%", mr: 2 }}>{data.value}</H4>
              </ListItemSecondaryAction>
            </ListItem>
            <Divider />
          </>
        ))}
      </List>
    </>
  );
};

export default FundInformation;
